import { Heart } from "lucide-react";
import { useFavorites } from "../lib/favorites";

export default function FavoriteButton({ kind, id, size = 20, className = "", label }) {
  const fav = useFavorites();
  if (!fav) return null;
  const active = fav.isFav(kind, id);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    fav.toggle(kind, id);
  };

  return (
    <button
      onClick={onClick}
      aria-label={active ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      title={active ? "Rimuovi dai preferiti" : "Aggiungi ai preferiti"}
      className={`inline-flex items-center gap-1.5 rounded-full border bg-white/95 backdrop-blur px-2 py-1 text-[11px] font-semibold transition-colors ${
        active
          ? "border-[#0153A3] text-[#0153A3]"
          : "border-[#E5E7EB] text-[#6B7280] hover:text-[#0153A3] hover:border-[#0153A3]"
      } ${className}`}
      data-testid={`fav-toggle-${kind}-${id}`}
    >
      <Heart size={size - 4} strokeWidth={2} fill={active ? "currentColor" : "none"} />
      {label}
    </button>
  );
}
